import React from 'react';
import classNames from 'classnames';
/**
 * @typedef {Object} ItemProps
 * @property {string} label
 * @property {boolean} [fullWidth]
 * @property {boolean} [tabletFullWidth]
 * @property {boolean} [mobileFullWidth]
 * @property {React.ReactNode} [children]
 */

/**
 * @param {ItemProps} props
 */
export let Item = ({label, children, tabletFullWidth, mobileFullWidth, fullWidth}) => (
    <div key={label}
         className={classNames([
             'gx-summary-list__item',
             fullWidth && 'gx-summary-list__item--fullWidth',
             mobileFullWidth && 'gx-summary-list__item--fullWidthMobile',
             tabletFullWidth && 'gx-summary-list__item--fullWidthTablet'
         ])}>
        <div className='gx-summary-list__label'>{label}</div>
        <div className='gx-summary-list__value'>{children}</div>
    </div>
);
